import {Component, HostListener, Input, OnInit} from '@angular/core';
import {CommonModule, NgOptimizedImage} from "@angular/common";
import {MatIconModule} from "@angular/material/icon";

@Component({
  selector: 'app-tooltip',
  standalone: true,
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  imports: [CommonModule, MatIconModule, NgOptimizedImage]
})
export class TooltipComponent implements OnInit {
  showTooltip: boolean = false;

  @Input() placement: 'top' | 'bottom' | 'left' | 'right' = 'top';
  @Input() minWidth?: number = 200;

  constructor() { }

  ngOnInit(): void {
  }

  @HostListener('mouseenter') onMouseenter(): void {
    this.showTooltip = true;
  }

  @HostListener('mouseleave') onMouseleave(): void {
    this.showTooltip = false;
  }

}
